var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-flex",
    { attrs: { sm12: "", md12: "" } },
    [
      _c("h2", { staticClass: "h2_title mb-1" }, [
        _vm._v(
          "\n    Información de Detalle de Reserva, Asignación y Preparación\n  "
        )
      ]),
      _c("v-divider"),
      _c(
        "v-flex",
        {
          attrs: {
            xs12: "",
            sm12: "",
            md12: "",
            "mt-5": "",
            layout: "",
            wrap: ""
          }
        },
        [
          _c(
            "v-flex",
            { attrs: { xs12: "", sm4: "", md4: "" } },
            [
              _c("v-text-field", {
                attrs: { label: "ndvnumero", disabled: "" },
                model: {
                  value: _vm.data["ndvnumero"],
                  callback: function($$v) {
                    _vm.$set(_vm.data, "ndvnumero", $$v)
                  },
                  expression: "data['ndvnumero']"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { xs12: "", sm4: "", md4: "" } },
            [
              _c("v-text-field", {
                attrs: { label: "EPC", disabled: "" },
                model: {
                  value: _vm.data["EPC"],
                  callback: function($$v) {
                    _vm.$set(_vm.data, "EPC", $$v)
                  },
                  expression: "data['EPC']"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { xs12: "", sm4: "", md4: "" } },
            [
              _c("v-text-field", {
                attrs: { label: "CRM Producto", disabled: "" },
                model: {
                  value: _vm.data["CRM Producto"],
                  callback: function($$v) {
                    _vm.$set(_vm.data, "CRM Producto", $$v)
                  },
                  expression: "data['CRM Producto']"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { xs12: "", sm4: "", md4: "" } },
            [
              _c("v-text-field", {
                attrs: { label: "CRM Plataforma", disabled: "" },
                model: {
                  value: _vm.data["CRM Plataforma"],
                  callback: function($$v) {
                    _vm.$set(_vm.data, "CRM Plataforma", $$v)
                  },
                  expression: "data['CRM Plataforma']"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { xs12: "", sm4: "", md4: "" } },
            [
              _c("v-text-field", {
                attrs: { label: "CRM EP", disabled: "" },
                model: {
                  value: _vm.data["CRM EP"],
                  callback: function($$v) {
                    _vm.$set(_vm.data, "CRM EP", $$v)
                  },
                  expression: "data['CRM EP']"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { xs12: "", sm6: "", md4: "" } },
            [
              _c("v-autocomplete", {
                attrs: {
                  items: _vm.series,
                  "item-text": "value",
                  "item-value": "key",
                  label: "CRM Serie"
                },
                model: {
                  value: _vm.selectedSerie,
                  callback: function($$v) {
                    _vm.selectedSerie = $$v
                  },
                  expression: "selectedSerie"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { xs12: "", sm4: "", md4: "" } },
            [
              _c("v-text-field", {
                attrs: { label: "Flota", disabled: "" },
                model: {
                  value: _vm.data["Flota"],
                  callback: function($$v) {
                    _vm.$set(_vm.data, "Flota", $$v)
                  },
                  expression: "data['Flota']"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { xs12: "", sm4: "", md4: "" } },
            [
              _c("v-text-field", {
                attrs: { label: "CRM Patente", disabled: "" },
                model: {
                  value: _vm.data["CRM Patente"],
                  callback: function($$v) {
                    _vm.$set(_vm.data, "CRM Patente", $$v)
                  },
                  expression: "data['CRM Patente']"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { xs12: "", sm4: "", md4: "" } },
            [
              _c("v-text-field", {
                attrs: { label: "Equipo", disabled: "" },
                model: {
                  value: _vm.data["Equipo"],
                  callback: function($$v) {
                    _vm.$set(_vm.data, "Equipo", $$v)
                  },
                  expression: "data['Equipo']"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { xs12: "", sm4: "", md4: "" } },
            [
              _c("v-text-field", {
                attrs: { label: "Serie Número", disabled: "" },
                model: {
                  value: _vm.data["Serie Número"],
                  callback: function($$v) {
                    _vm.$set(_vm.data, "Serie Número", $$v)
                  },
                  expression: "data['Serie Número']"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { xs12: "", sm4: "", md4: "" } },
            [
              _c("v-text-field", {
                attrs: { label: "Serie Activa Número", disabled: "" },
                model: {
                  value: _vm.data["Serie Activa Número"],
                  callback: function($$v) {
                    _vm.$set(_vm.data, "Serie Activa Número", $$v)
                  },
                  expression: "data['Serie Activa Número']"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { xs12: "", sm4: "", md4: "" } },
            [
              _c("v-text-field", {
                attrs: { label: "Fecha de Instalación", disabled: "" },
                model: {
                  value: _vm.data["Fecha de Instalación"],
                  callback: function($$v) {
                    _vm.$set(_vm.data, "Fecha de Instalación", $$v)
                  },
                  expression: "data['Fecha de Instalación']"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { xs12: "", sm4: "", md4: "" } },
            [
              _c("v-text-field", {
                attrs: { label: "Atención Número", disabled: "" },
                model: {
                  value: _vm.data["Atención Número"],
                  callback: function($$v) {
                    _vm.$set(_vm.data, "Atención Número", $$v)
                  },
                  expression: "data['Atención Número']"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { xs12: "", sm12: "", md12: "" } },
            [
              _c(
                "v-flex",
                {
                  staticStyle: { "text-align": "end" },
                  attrs: { xs4: "", sm12: "", md12: "" }
                },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "btn-volver white--text",
                      on: { click: _vm.handleCancel }
                    },
                    [_vm._v("Cancelar")]
                  ),
                  _c(
                    "v-btn",
                    {
                      staticClass: "btn-grabar white--text",
                      on: { click: _vm.edit }
                    },
                    [_vm._v("Confirmar")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }